import { DEFAULT_GROSS_WEIGHT_UNIT } from "./gpsrWizardConstants";

export const displayText = (value) => String(value ?? "").trim();

const TARGET_MARKET_DISPLAY_LABELS = {
  EU: "European Union",
  GBR: "United Kingdom",
};

export const hydrateTargetMarketCodes = (value) => {
  const list = Array.isArray(value)
    ? value
    : value == null || value === ""
      ? []
      : [value];

  return list.map((item) => displayText(item)).filter(Boolean);
};

export const formatTargetMarketDisplay = (value, emptyDisplay = "—") => {
  const codes = hydrateTargetMarketCodes(value);
  if (codes.length === 0) return emptyDisplay;
  return codes
    .map((code) => TARGET_MARKET_DISPLAY_LABELS[code] || code)
    .join(", ");
};

export const buildStreetAddress = (info = {}) =>
  [info.street, info.housenum, info.apartment]
    .map((part) => String(part ?? "").trim())
    .filter(Boolean)
    .join(", ");

export const buildEmptyParty = () => ({
  companyName: "",
  streetAddress: "",
  postalCode: "",
  city: "",
  country: "",
  email: "",
});

export const buildInitialManufacturer = (company = {}) => {
  const info =
    company?.info && typeof company.info === "object" ? company.info : {};
  return {
    businessName: "",
    companyName: String(company?.name ?? "").trim(),
    streetAddress: buildStreetAddress(info),
    postalCode: String(info.postcode ?? "").trim(),
    city: String(info.locality ?? "").trim(),
    country: String(company?.country_id ?? company?.country ?? "").trim(),
    email: String(company?.email ?? "").trim(),
  };
};

export const buildInitialRepresentative = (productState = {}) => {
  const type = productState?.representative_type;
  const custom = {
    companyName: displayText(productState?.representative_company_name),
    streetAddress: displayText(productState?.representative_address_line),
    postalCode: displayText(productState?.representative_postal_code),
    city: displayText(productState?.representative_city),
    country: displayText(
      productState?.representative_country ??
        productState?.representative_country_id
    ),
    email: displayText(productState?.representative_email),
  };
  if (type == null || type === "") {
    return { enabled: false, mode: "lappa", custom };
  }
  return {
    enabled: true,
    mode: String(type) === "custom" ? "custom" : "lappa",
    custom,
  };
};

export const buildInitialImporter = () => ({
  enabled: false,
  ...buildEmptyParty(),
});

export const buildInitialTraceability = (productState = {}) => ({
  productName: displayText(productState.name ?? productState.description),
  batchLotNumber: "",
  size: "",
  grossWeight: "",
  grossWeightUnit: DEFAULT_GROSS_WEIGHT_UNIT,
  productType: "",
  expiryDate: "",
  barcode: "",
  colourVariant: "",
  model: "",
  gpcCode: "",
  sku: displayText(productState.sku),
  countryOfOrigin: "",
  targetMarket: hydrateTargetMarketCodes(
    productState.target_market ?? productState.targetMarket
  ),
});
